/* unplugin-vue-components disabled */import script from "./MessagesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessagesList.vue?vue&type=script&lang=ts&setup=true"

import "./MessagesList.vue?vue&type=style&index=0&id=46da80cb&lang=scss"

const __exports__ = script;

export default __exports__